import CustomFrame from './CustomFrame';

export default CustomFrame;
